import "./statusViewer.scss";

const StatusViewer = ({ status }) => {
  const indicatorModificatorClass = (status) => {
    if (status === "Draft") {
      return "status-viewer__indicator--draft";
    } else if (status === "Review") {
      return "status-viewer__indicator--review";
    } else if (status === "Approved") {
      return "status-viewer__indicator--approved";
    } else if (status === "Published" || status === "Publishing") {
      return "status-viewer__indicator--published";
    } else if (status === "Obsolete") {
      return "status-viewer__indicator--obsolete";
    }
    return "";   
  };
  
  return (
    <div className="status-viewer">
      <i className={`status-viewer__indicator ${indicatorModificatorClass(status)}`}></i>
      <span className="status-viewer__name">{status}</span>
    </div>
  );
};

export default StatusViewer;
